module.exports = __webpack_public_path__ + "static/media/4.4202f385.svg";